// disable1password.ts
const isElementNodeType = (node: Node): node is Element => node.nodeType === Node.ELEMENT_NODE;

// Remove 1Password from page
new MutationObserver((mutations: MutationRecord[]) => {
    for (const { addedNodes } of mutations) {
        for (const node of addedNodes) {
            if (!isElementNodeType(node)) {
                continue;
            }

            if (node.tagName === 'COM-1PASSWORD-BUTTON' || node.tagName === 'COM-1PASSWORD-MENU') {
                node.parentNode?.removeChild(node);
            }
        }
    }
}).observe(document.body, { childList: true });
